import { render } from "./ReportDetailsPage.vue?vue&type=template&id=4dd8f5f9&scoped=true"
import script from "./ReportDetailsPage.vue?vue&type=script&lang=js"
export * from "./ReportDetailsPage.vue?vue&type=script&lang=js"

import "./ReportDetailsPage.vue?vue&type=style&index=0&id=4dd8f5f9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd8f5f9"]])

export default __exports__